import { resolveParentMessageOrigin } from "./parentOrigin";

type CheckoutMessageType =
  | "ready"
  | "payment_success"
  | "payment_failed"
  | "closed";

export type PaymentResultPayload = {
  sessionId: string;
  orderId?: string;
  amount?: number;
  currency?: string;
};

type CheckoutMessage = {
  source: "estiapay-checkout";
  type: CheckoutMessageType;
  sessionId: string;
  payload?: Record<string, unknown>;
};

function isTrustedParentOrigin(origin: string): boolean {
  if (origin === "*") {
    return false;
  }
  try {
    const parsed = new URL(origin);
    return parsed.protocol === "https:" || parsed.protocol === "http:";
  } catch {
    return false;
  }
}

function notifyParent(
  type: CheckoutMessageType,
  sessionId: string,
  payload?: Record<string, unknown>,
): void {
  const targetOrigin = resolveParentMessageOrigin();
  if (!targetOrigin || !isTrustedParentOrigin(targetOrigin)) {
    return;
  }

  const message: CheckoutMessage = {
    source: "estiapay-checkout",
    type,
    sessionId,
  };

  if (payload) {
    message.payload = payload;
  }

  // Origin parsed + validated above; never "*".
  globalThis.parent.postMessage(message, targetOrigin); // NOSONAR
}

export function notifyParentCheckoutReady(sessionId: string): void {
  notifyParent("ready", sessionId, { sessionId });
}

export function notifyParentPaymentSuccess(
  sessionId: string,
  payload: PaymentResultPayload,
): void {
  notifyParent("payment_success", sessionId, { ...payload });
}

export function notifyParentPaymentFailed(
  sessionId: string,
  payload: PaymentResultPayload,
): void {
  notifyParent("payment_failed", sessionId, { ...payload });
}

export function notifyParentCheckoutClosed(sessionId: string): void {
  notifyParent("closed", sessionId);
}
